import React from 'react'
import MyListBlock from '../../../../UI/list/MyListBlock'
import { useState } from 'react'
import { useEffect } from 'react'
// import { unitMeasureShortText } from '../../../../../helpers/unitMeasure/UnitMeasureHelper'
import AgreeDirectorButton from '../../forms/agreeDirector/AgreeDirectorButton'
import AgreeAccountantButton from '../../forms/agreeAccountant/AgreeAccountantButton'
import WriteOffActItemButton from './form/WriteOffActItemButton'
import ChangeNameInActButton from '../../forms/changeNameInAct/ChangeNameInActButton'
import ChangeNomenclatureNumberButton from '../../forms/changeNomenclatureNumber/ChangeNomenclatureNumberButton'
import ChangeInventoryNumberButton from '../../forms/changeInventoryNumber/ChangeInventoryNumberButton'
import ChangeDateReceiptButton from '../../forms/changeDateReceipt/ChangeDateReceiptButton'
import ChangeServiceLifeButton from '../../forms/changeServiceLife/ChangeServiceLifeButton'
import ChangePassportNumberButton from '../../forms/changePassportNumber/ChangePassportNumberButton'
import ChangePriceWriteOffActItemButton from '../../forms/changePriceWriteOffActItem/ChangePriceWriteOffActItemButton'
import WriteOffActItemJunk from './junk/WriteOffActItemJunk'
import MyCheckBox from '../../../../UI/form/MyCheckBox'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

const WriteOffActItem = ({ writeOffActItem, index }) => {

    const unitMeasures = useSelector(state => state.settings.unitMeasures)
    const unitMeasure = unitMeasures && unitMeasures[writeOffActItem.unitMeasure] ? unitMeasures[writeOffActItem.unitMeasure].name : '?'

    const [list, setList] = useState([])
    const [listSecond, setListSecond] = useState([])

    const [isJunk, setIsJunk] = useState(false)

    useEffect(() => {
        setListItems()
        setListSecondItems()
    }, [writeOffActItem])

    const setListItems = () => {
        const listTemp = []

        listTemp.push({
            // name: '№ (ID)',
            // value: `${index + 1} (${supplyBillItem.id})`
            name: 'ID',
            value: writeOffActItem.id
        })
        // listTemp.push({
        //     name: 'Підрозділ',
        //     value: 
        //         // supplyBillItem.supplyOrder
        //         writeOffActItem.supplyOrder.departmentType ? supplyBillItem.supplyOrder.departmentType.name + ' - ' + supplyBillItem.supplyOrder.department.name : '-'
        // })
        listTemp.push({
            name: 'ID рахунку',
            value: 
                <Link to={`/supply/bills/${writeOffActItem.supplyBillId}`}>
                    {writeOffActItem.supplyBillId}
                </Link>
        })
        listTemp.push({
            name: 'Назва',
            value: writeOffActItem.name
        })
        listTemp.push({
            name: 'Кількість',
            // value: writeOffActItem.count + ' ' + unitMeasureShortText[writeOffActItem.unitMeasure]
            value: writeOffActItem.count + ' ' + unitMeasure
        })
        // listTemp.push({
        //     name: 'Назва в акті',
        //     value: 
        //         <ChangeNameInActButton
        //             writeOffActItem={writeOffActItem}
        //         />
        // })
        listTemp.push({
            name: 'Причина списання',
            value: writeOffActItem.reason
        })
        listTemp.push({
            name: 'Номенклатурний номер',
            value: 
                <ChangeNomenclatureNumberButton
                    writeOffActItem={writeOffActItem}
                />
        })
        listTemp.push({
            name: 'Інвентарний номер',
            value: 
                <ChangeInventoryNumberButton
                    writeOffActItem={writeOffActItem}
                />
        })
        listTemp.push({
            name: 'Дата надходження',
            value: 
                <ChangeDateReceiptButton
                    writeOffActItem={writeOffActItem}
                />
        })
        listTemp.push({
            name: 'Строк служби',
            value: 
                <ChangeServiceLifeButton
                    writeOffActItem={writeOffActItem}
                />
        })
        listTemp.push({
            name: 'Номер паспорта',
            value: 
                <ChangePassportNumberButton
                    writeOffActItem={writeOffActItem}
                />
        })

        setList(listTemp)
    }

    const setListSecondItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'Вартість',
            value: 
                <ChangePriceWriteOffActItemButton
                    writeOffActItem={writeOffActItem}
                />
        })
        listTemp.push({
            name: 'Погодження',
            value: 
                <div className='supplyAgrees'>
                    <AgreeDirectorButton
                        writeOffActItem={writeOffActItem}
                    />
                    <AgreeAccountantButton
                        writeOffActItem={writeOffActItem}
                    />
                </div>
        })
        listTemp.push({
            name: 'Дії з позицією',
            value: 
                <>
                    <WriteOffActItemButton 
                        writeOffActItem={writeOffActItem}
                    />
                </> 
                // <DeleteBillItemButton
                //     supplyBillItem={supplyBillItem}
                // />
        })
        // listTemp.push({
        //     name: 'Брухт',
        //     value: 
        //         <MyCheckBox 
        //             value={isJunk}
        //             setValue={setIsJunk}
        //             label='Чи є брухтом?'
        //         />
        // })

        setListSecond(listTemp)
    }

  return (
    <>
        <div className='supplyBillItem__one'>
            {/* <div> */}
                <MyListBlock
                    className={'supplyOrderView__topBlock myListBlock__wrap'}
                    text={`Позиція №${index + 1}`}
                    list={list} 
                />
            {/* </div> */}
            <MyListBlock 
                className={'supplyOrderView__topBlock w250'}
                // text={`Позиція №${index + 1}`}
                list={listSecond} 
            />
        </div>
        {
            isJunk ?
                <WriteOffActItemJunk 
                    writeOffActItem={writeOffActItem}
                />
            : ''
        }
    </>
  )
}

export default WriteOffActItem